import * as Constants from './constants'

export const tonKhoListRequest = function tonKhoListRequest(formData) {
  return {
    type: Constants.TONKHO_LIST_REQUESTING,
    payload: formData
  }
}

export const tonKhoListSuccess = function tonKhoListSuccess(data) {
  return {
    type: Constants.TONKHO_LIST_SUCCESS,
    data
  }
}

export const tonKhoListError = function tonKhoListError(error) {
  return {
    type: Constants.TONKHO_LIST_ERROR,
    error
  }
}

export const tonKhoDetailRequest = function tonKhoDetailRequest(formData) {
  return {
    type: Constants.TONKHO_DETAIL_REQUESTING,
    payload: formData
  }
}

export const tonKhoDetailSuccess = function tonKhoDetailSuccess(data) {
  return {
    type: Constants.TONKHO_DETAIL_SUCCESS,
    data
  }
}

export const tonKhoDetailError = function tonKhoDetailError(error) {
  return {
    type: Constants.TONKHO_DETAIL_ERROR,
    error
  }
}

export const tonKhoUpdateRequest = (formData, callback) => {
  return {
    type: Constants.TONKHO_UPDATE_REQUESTING,
    payload: formData,
    callback
  }
}

export const tonKhoUpdateSuccess = function tonKhoUpdateSuccess(response) {
  return {
    type: Constants.TONKHO_UPDATE_SUCCESS,
    payload: response
  }
}

export const tonKhoUpdateError = function tonKhoUpdateError(error) {
  return {
    type: Constants.TONKHO_UPDATE_ERROR,
    error
  }
}

export const khoListRequest = function khoListRequest(formData) {
  return {
    type: Constants.TONKHO_KHO_LIST_REQUESTING,
    payload: formData
  }
}

export const khoListSuccess = function khoListSuccess(data) {
  return {
    type: Constants.TONKHO_KHO_LIST_SUCCESS,
    data
  }
}

export const khoListError = function khoListError(error) {
  return {
    type: Constants.TONKHO_KHO_LIST_ERROR,
    error
  }
}

export const tonKhoExportXlsRequest = function tonKhoExportXlsRequest(formData) {
  return {
    type: Constants.TONKHO_EXPORT_REQUESTING,
    payload: formData
  }
}

export const tonKhoExportXlsSuccess = function tonKhoExportXlsSuccess(data) {
  return {
    type: Constants.TONKHO_EXPORT_SUCCESS,
    data
  }
}

export const tonKhoExportXlsError = function tonKhoExportXlsError(error) {
  return {
    type: Constants.TONKHO_EXPORT_ERROR,
    error
  }
}

export const tonKhoUploadRequest = (formData, callback) => {
  return {
    type: Constants.TONKHO_UPLOAD_REQUESTING,
    payload: formData,
    callback
  }
}

export const tonKhoUploadSuccess = function tonKhoUploadSuccess(response) {
  return {
    type: Constants.TONKHO_UPLOAD_SUCCESS,
    payload: response
  }
}

export const tonKhoUploadError = function tonKhoUploadError(error) {
  return {
    type: Constants.TONKHO_UPLOAD_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/TonKho/actions.js